import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptStopPropagationDirective } from "@common/ux/stop-propagation.directive";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AutosaveComponent } from "./autosave.component";


@NgModule({
    declarations: [
        AutosaveComponent,
    ],
    imports: [
        CommonModule,
        AdaptButtonModule,
        AdaptTooltipModule,
        AdaptStopPropagationDirective,
    ],
    exports: [
        AutosaveComponent,
    ],
})
export class AdaptAutosaveModule {
}
